import {
  pathogenicityIndex,
  NOT_APPLICABLE,
} from "../browsers/Pulsar/constants/pathogenicity";
import CNV_TYPES from "../browsers/Pulsar/constants/supportedCnv";
import Region from "./Region";
import {
  DELETION,
  DUPLICATION,
  BREAKEND,
  REPEAT_EXPANSION,
  INSERTION,
} from "../browsers/Pulsar/constants/structuralVariants";

const unknownPathoIndex = pathogenicityIndex[NOT_APPLICABLE];

class ClinicalSampleCnv {
  constructor(data = {}, chr) {
    const { position, length } = data;
    const pos = position;
    const passesAllQuality = data.passes_all_quality_checks ? 1 : 0;
    const failsAllQuality = data.fails_all_quality_checks ? 3 : 0;
    const passesSome = passesAllQuality || failsAllQuality ? 0 : 2;

    this.pathoIndex = pathogenicityIndex[data.acmg_class] ?? unknownPathoIndex;
    this.region = new Region(pos, pos + length, chr);
    this.inAnalyses = data.inAnalyses;
    this.inSamples = data.inSamples;
    this.acmgRules = (data?.ACMG_rules || []).map((x) => x.split("_"));
    this.zygosity = data.zygosity ?? "-";
    this.type = data.type;
    this.id = `${this.region.g0}-${this.region.size}-${this.type}`;
    this.qualityIndex = passesAllQuality || failsAllQuality || passesSome;
    this.analysisDict = data.analysisDict || {};
    this.alt = data.alt;

    // breakends
    this.breakendType = data.breakend_info?.breakend_type;
    this.breakendInsertedSeq = data.breakend_info?.inserted_sequence;
    this.breakendConnectedChromo = data.breakend_info?.connected_chromosome;
    this.breakendConnectedPos = data.breakend_info?.connected_position + 1;

    // repeat expansions
    this.genes = data?.genes;
    this.sampleRepeats = data.sampleRepeats;
    this.repeatUnit = data.repeatUnit;
    this.minPathoRepeats = data.minPathoRepeats;
  }

  get spec() {
    const type = CNV_TYPES[this.type];
    if (!type) return null;
    return `${this.region.chromosome.name}:${this.region.x0}:L${this.region.size}:${type}`;
  }

  get desc() {
    return `${this.region.chromosome.name}:${this.region.x0}:L${this.region.size}`;
  }

  get link() {
    const type = CNV_TYPES[this.type];
    if (!type) return null;
    return `/cnv/${this.region.chromosome.genomeId}/${this.region.chromosome.name}:${this.region.x0}:L${this.region.size}:${type}`;
  }

  get isBreakend() {
    return this.type === BREAKEND;
  }

  get isInsertion() {
    return this.type === INSERTION;
  }

  get isCNV() {
    return this.type === DELETION || this.type === DUPLICATION;
  }

  get isRepeatExpansion() {
    return this.type === REPEAT_EXPANSION;
  }
}

export default ClinicalSampleCnv;
